import { render } from "./IssueHistory.vue?vue&type=template&id=08f127d4"
import script from "./IssueHistory.vue?vue&type=script&lang=js"
export * from "./IssueHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__